export default "__VITE_ASSET__0463b411__"